export class HttpModule {
    constructor(url, errorInterceptor) {
        this.url = url;
        this.errorInterceptor = errorInterceptor;
    }
    async fetch(route, init = {}) {
        init.headers = init.headers || {};
        if (this.token) {
            init.headers.Authorization = `Bearer ${this.token}`;
        }
        const res = await globalThis.fetch(`${this.url}${route}`, init);
        if (res.status >= 300) {
            const errorPayload = (await res.json());
            const error = new PolyratingsHttpError(errorPayload.message, res.status);
            this.errorInterceptor(error);
            throw error;
        }
        return res;
    }
    setAuthToken(jwt) {
        this.token = jwt;
    }
    getAuthToken() {
        return this.token;
    }
}
export class PolyratingsHttpError extends Error {
    constructor(message, httpStatus) {
        super(message);
        this.httpStatus = httpStatus;
    }
}
//# sourceMappingURL=Http.module.js.map